import * as actiontypes from '../constants/ActionTypes'
import * as general from '../constants/General'
import * as status from '../constants/Status'
import * as types from '../constants/Types'
import * as functions from '../constants/Functions'
import * as generalActions from './generalActions'
import * as layoutActions from './layoutActions'
import * as resource from '../constants/Resources'
import * as receiptFunctions from '../functions/ReceiptFunctions'
import * as rl from '../models/ReceiptLine'
import * as loginActions from './loginActions'
import * as dataActions from './dataActions'
import * as invoiceActions from './invoiceActions'
import * as keyFunctionActions from './keyFunctionActions'
import * as modalActions from '../modal/actions/modalActions'
import * as paymentFunctions from '../functions/PaymentFunctions';
import fetch from 'isomorphic-fetch'
import { hashHistory } from 'react-router';
import $ from 'jquery'
import * as systemSetting from '../constants/SystemSettings'

export function setInputQuantity(quantity) {
  return {
    type: actiontypes.INPUT_QUANTITY,
    quantity
  }
}
export function setInputQuantityDecimal(inputQuantityDecimal) {
  return {
    type: actiontypes.INPUT_QUANTITY_DECIMAL,
    inputQuantityDecimal
  }
}
export function setInputQuantityNegative(inputquantitynegative) {
  return {
    type: actiontypes.INPUT_QUANTITY_NEGATIVE,
    inputquantitynegative
  }
}

export function resetInputQuantity() {
  return (dispatch) => {
    dispatch(setInputQuantity('0'));
    dispatch(setInputQuantityNegative(false));
  }
}

export function emptyReceipt(cancel) {
  return {
    type: actiontypes.EMPTY_RECEIPT,
    cancel
  }
}

export function setCancelOnAbort() {
  return {
    type: actiontypes.SET_CANCEL_ON_ABORT
  }
}

// fetch latest customer info from api
export function getSyncCustomer(customerid) {
  return (dispatch, getState) => {
    const apiUrlCustomer = `${general.API_URL_GETSYNCCUSTOMER}${customerid}`;
    fetch(apiUrlCustomer, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:getSyncCustomer'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json) {
          return json;
        }
        else {
          return null
        }
      });
  }
}

export function SetStock(receiptID) {
  return (dispatch, getState) => {
    //When receipt is finished then manipulate stock
    var stockParams = {
      receiptID: receiptID,
    }
    fetch(general.API_URL_SET_STOCK, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Context': 'PaymentFunctions:SetStock'
      },

      body: JSON.stringify(stockParams)
    }).then(
      fetch(general.API_URL_GET_STOCK_MESSAGE, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Context': 'PaymentFunctions:GetStockMessage'
        },
        body: JSON.stringify(stockParams)
      }).then(response => response.json())
        .then(json => {
          if (json.length !== 0) {
            var msg = dispatch(dataActions.getTranslation(resource.STOCKMESSAGE_MINSTOCK)) + ":\n";
            json.forEach(article => msg += article.Description + ": " + article.TotalStock + " stock\n");
            dispatch(generalActions.setMessageModal(true, msg));
          }
        })
    );
  }
}

export function printNota(templateId) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    const printNotaUrl = general.API_URL_PRINT_NOTA + (templateId != null ? '/' + templateId : '');
    fetch(printNotaUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:printNota'
      },
      body: JSON.stringify(dispatch(receiptFunctions.saveReceipt()))
    })
      .then(response => response.json())
      .then(json => {
        if (json) {
          dispatch(keyFunctionActions.processFunction(functions.ObjectManagementClose));
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_PRINTING_NOTE))));
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()))
      .catch(() => {
        dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_PRINTING_NOTE))));
        dispatch(generalActions.loadingEnd());
      });
  }
}

export function fastPayment(param, cancelOnAbort) {
  return async (dispatch, getState) => {

    const state = getState();
    var paymentParam = JSON.parse(param);
    var paymentId = (paymentParam && paymentParam.SetPayment) ? parseInt(paymentParam.SetPayment, 10) : -1;
    var paymentAmount = (paymentParam && paymentParam.SetPaymentAmount) ? parseFloat(paymentParam.SetPaymentAmount, 10) : -1;
    var paymentmethods = state.generalState.paymentMethod.all
    var paymentChangeId = (paymentParam && paymentParam.SetPaymentChange) ? parseInt(paymentParam.SetPaymentChange, 10) : -1;
    var isPaymentChange = paymentChangeId > 0 ? true : false;

    // Check if receipt is empty
    if ((!getState().receiptState.receipt.lines || getState().receiptState.receipt.lines.length === 0) && isPaymentChange === false) {
      return;
    }

    let receiptAmount = await dispatch(getReceiptAmount());
    if (paymentAmount === -1) {
      paymentAmount = await dispatch(paymentFunctions.getPaymentAmount());
    }

    if (cancelOnAbort)
      dispatch(setCancelOnAbort());

    if (paymentId > 0) {
      const disablePaymentsWithInvoice = getState().generalState.systemSettings[systemSetting.DISABLE_PAYMENTS_WITH_INVOICE];
      const shouldinvoice = getState().receiptState.receipt.shouldinvoice;
      var cancelPayment = false;
      paymentmethods.forEach(paymentMethod => {
        if (paymentMethod.PaymentId === paymentId) {
          if ((disablePaymentsWithInvoice === true && (shouldinvoice === (!paymentMethod.ShouldInvoice && !paymentMethod.AllowInvoice))) ||
            (!(disablePaymentsWithInvoice === false) && (((paymentMethod.ShouldInvoice && (!shouldinvoice))) || (shouldinvoice && (!paymentMethod.ShouldInvoice) && (!paymentMethod.AllowInvoice))))
          ) {
            cancelPayment = true;
            if (getState().receiptState.receipt.shouldinvoice) {
              dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_PAYMENTMETHOD_FOR_INVOICE))));
            } else {
              dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PAYMENTMETHOD_FOR_INVOICE))));
            }
          } else if (paymentMethod.DisableOverpayment === true) {
            if (paymentAmount > receiptAmount) {
              cancelPayment = true;
              dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_OVERPAYMENT_ALLOWED))));
            }
          }
        }
      })
      if (cancelPayment === true) {
        return;
      }
      if (paymentChangeId > 0) {
        dispatch(setTemporaryDefaultChangeId(paymentChangeId));
      }
      // Check if receiptnumber exists
      if (state.receiptState.receipt.receiptnumber === null
        || state.receiptState.receipt.receiptnumber === '') {
        const inputquantitynegative = state.receiptState.input.inputquantitynegative;
        await dispatch(createReceipt(inputquantitynegative)).then(() => dispatch(paymentFunctions.continuePayment(paymentId, paymentAmount, paymentChangeId)));
      }
      else {
        dispatch(paymentFunctions.continuePayment(paymentId, paymentAmount, paymentChangeId));
      }
    }
    else {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_PAYMENT_METHOD_SELECTED))));
      return;
    }
  }
}

function setBlackboxReceiptId(receiptId, printed) {
  return (dispatch, getState) => {
    let newReceiptId = receiptId;
    if (printed) {
      newReceiptId = 0;
    }
    dispatch(generalActions.setBlackboxReceiptId(newReceiptId));

    const param = {
      PosId: getState().generalState.posId,
      ReceiptId: receiptId,
      PosDeviceGuid: getState().generalState.uniqueid,
      UserId: getState().loginState.loggedin.id,
      Printed: printed
    }

    fetch(general.API_URL_BLACKBOXRECEIPT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:setBlackboxReceiptId'
      },
      body: JSON.stringify(param)
    })
  }
}

function processNotPrinted(receiptId, deviceId, status, statusMessage) {
  return (dispatch, getState) => {
    if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) {
      dispatch(setBlackboxReceiptId(receiptId, false));
    }
    dispatch(generalActions.updateStatus(deviceId, status, statusMessage));
  }
}

export function reprintReceipt(receiptId, deviceId, posDeviceLinkId) {
  return (dispatch, getState) => {
    const param = {
      ReceiptId: receiptId,
      DeviceId: deviceId,
      PosDeviceLinkId: posDeviceLinkId
    }
    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_REPRINT_RECEIPT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:reprintReceipt'
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(json => {
        if (json.Status >= status.RECEIPT_PRINT_FAILED) {
          dispatch(processNotPrinted(receiptId, deviceId, json.Status, json.StatusMessage));
          dispatch(generalActions.setMessageModal(true, json.StatusMessage));
        } else {
          dispatch(setBlackboxReceiptId(receiptId, true));
          dispatch(generalActions.updateStatus(json.DeviceId, json.Status, json.StatusMessage));
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()));
  }
}

function validateEmail(email) {
  // eslint-disable-next-line
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function sendReceiptWithEmail(email, receipt) {
  return (dispatch, getState) => {
    dispatch(generalActions.log(`Save receipt: ${receipt.ReceiptNumber}`, false));

    if (email === null || (email !== '' && validateEmail(email))) {
      dispatch(generalActions.loadingStart());

      receipt.Email = email;

      const customerId = getState().receiptState.receipt.customer.customerid;

      if (customerId > 0) {
        receipt.CustomerId = customerId;
      }
      const state = getState();
      const age = state.receiptState && state.receiptState.receipt && state.receiptState.receipt.age;
      if (age) {
        receipt.Age = age;
      }

      if (receipt.PriceListId == null) {
        receipt.PriceListId = 0;
      }

      const jsonReceipt = JSON.stringify(receipt);

      fetch(general.API_URL_SAVE_RECEIPT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:sendReceiptWithEmail'
        },
        body: jsonReceipt
      })
        .then(response => generalActions.checkLicense(response, dispatch))
        .then(response => response.json())
        .then(json => {
          if (json.Status === status.RECEIPT_EMPTY
            || json.Status === status.RECEIPT_UNKOWNERROR) {
            var message = dispatch(dataActions.getTranslation(json.Message));
            dispatch(generalActions.setMessageModal(true, message));
            dispatch(generalActions.log(`Failed sendReceiptWithEmail (status ${json.Status}) - ${message}: ${jsonReceipt}`));
          } else {
            dispatch(generalActions.log(`Receipt ${receipt.ReceiptNumber} saved`, false));
            dispatch(SetStock(json.ReceiptId));
            json.DeviceStates.map((device) => {
              if (json.Status >= status.RECEIPT_PRINT_FAILED && device.Status !== status.PRINTER_OK) {
                dispatch(generalActions.log(`Print receipt ${receipt.ReceiptNumber} failed`, false));

                dispatch(generalActions.setConfirmModal(
                  dispatch(dataActions.getTranslation(resource.MESSAGE_PRINTING_FAILED)),
                  reprintReceipt,
                  processNotPrinted,
                  [json.ReceiptId, device.DeviceId, device.PosDeviceLinkId],
                  [json.ReceiptId, device.DeviceId, device.Status, device.StatusMessage]
                ));
              } else {
                dispatch(generalActions.updateStatus(device.DeviceId, device.Status, device.StatusMessage));
              }
              return ''
            });
            dispatch(generalActions.setPreviousReceiptId(json.ReceiptId));

            if (json.Status <= status.RECEIPT_PRINT_FAILED) {
              dispatch(emptyReceipt(false));
              dispatch(generalActions.log(`Pos cleared`, false));

              const user = dispatch(dataActions.getSystemUser(getState().loginState.loggedin.id));
              if (user !== null && user.ObjectItems.length === 1) {
                const objectItem = dispatch(dataActions.getObjectItem(user.ObjectItems[0]));
                if (objectItem !== null) {
                  dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
                }
              } else {
                const pos = dispatch(dataActions.getPos(getState().generalState.posId));
                if (pos !== null
                  && pos.ObjectManagementRequired
                  && getState().loginState.loggedin.id > 0) {

                  dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
                  dispatch(keyFunctionActions.processObjectManagementOpen());
                }
              }
            } else {
              dispatch(generalActions.setMessageModal(true, json.Message));
            }
          }
        }).then(() => {
          if (receipt.ShouldInvoice) {
            dispatch(invoiceActions.sendInvoice(receipt.CustomerId));
          }
        }).then(() => {
          dispatch(generalActions.loadingEnd());
        });
    }
    else {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_VALID_EMAIL))));
      dispatch(saveReceipt());

      if (receipt.ShouldInvoice) {
        dispatch(invoiceActions.sendInvoice(receipt.CustomerId));
      }
    }
  }
}

function sendReceipt(receipt) {
  return (dispatch, getState) => {

    //GET RECEIPTPRINTER
    const receiptPrinter = receipt.Devices.find(device => device.status === status.PRINTER_OK && device.printertype === 100);

    if (receiptPrinter && receiptPrinter.devicetype === 600) { //PDF Printer
      //ASK FOR EMAIL ADDRESS     
      dispatch(layoutActions.toggleKeyboard(true, null, dispatch(dataActions.getTranslation(resource.EMAIL)), sendReceiptWithEmail, [receipt], true));
    } else {
      dispatch(sendReceiptWithEmail(null, receipt));
    }
  }
}

export function saveReceipt() {
  return (dispatch, getState) => {
    const receipt = dispatch(receiptFunctions.saveReceipt());
    const orderNumber = getState().receiptState.receipt.orderNumber;
    const items = [];
    receipt.Devices.map(device => {
      if (device.printertype === 100
        && device.status === status.PRINTER_OK) {
        items.push({
          ItemId: device.posdevicelinkid,
          Description: device.description
        });
      }
      return '';
    });

    receipt.orderNumber = orderNumber;

    if (items.length <= 1) {
      dispatch(sendReceipt(receipt));
      if (orderNumber != null) {
        dispatch(payOrder(orderNumber));
      }
    } else {
      dispatch(generalActions.setSelectModal(items, true, dispatch(dataActions.getTranslation(resource.CHOOSE_PRINTER)), continueSaveReceipt));
    }
  }
}
export function continueSaveReceipt(posDeviceLinkId) {
  return (dispatch, getState) => {
    const receipt = dispatch(receiptFunctions.saveReceipt());

    const devices = [];
    receipt.Devices.map(device => {
      if (device.printertype === 100) {
        if (device.posdevicelinkid === posDeviceLinkId) {
          devices.push(device);
        }
      }
      else {
        devices.push(device);
      }

      return '';
    });
    receipt.Devices = devices;
    dispatch(sendReceipt(receipt));
  }
}

export function splitReceipt(leftreceipt, rightreceipt) {
  return (dispatch, getState) => {
    const receipts = {
      LeftReceipt: leftreceipt,
      RightReceipt: rightreceipt
    }

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_SPLIT_RECEIPT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:splitReceipt'
      },
      body: JSON.stringify(receipts)
    })
      .then(response => response.json())
      .then(json => {
        if (json.Status === status.RECEIPT_UNKOWNERROR) {
          dispatch(generalActions.setMessageModal(true, json.Message));
        } else {
          const lines = receiptFunctions.openReceipt(json.Receipt);
          dispatch(receiveReceiptByObjectItem(lines, json.Receipt.ReceiptNumber, json.Receipt.IsRefund, json.Receipt.ObjectItemId, json.Receipt.ObjectItemName, json.Receipt.CombinedObjectItems, json.Receipt.ShouldInvoice));
          dispatch(setObjectItem(json.Receipt.ObjectItemId));
        }
      })
      .then(() => {
        dispatch(generalActions.loadingEnd())
      });
  }
}

const removeLastOrder = () => {
  return {
    type: actiontypes.REMOVE_LAST_ORDER
  }
}

export function closeReceipt(isUserLoggingOut, cancelSave) {
  return function (dispatch, getState) {
    dispatch(generalActions.loadingStart());
    dispatch(loginActions.setLogOut(true));

    if (cancelSave) {
      // the user clicked "Stop receipt". We already have a subtotal however, so
      // cancelReceipt redirected us here. We will look up the last 
      // subtotal and remove all the lines after that, so nothing new is saved and
      // the table is closed in the usual fasion
      dispatch(removeLastOrder());
    }

    const receipt = dispatch(receiptFunctions.saveReceipt());
    const jsonReceipt = JSON.stringify(receipt);

    return fetch(general.API_URL_CLOSE_RECEIPT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:closeReceipt'
      },
      body: jsonReceipt
    })
      .then(response => generalActions.checkLicense(response, dispatch))
      .then(response => response.json())
      .then(json => {
        //400 = empty receipt which means something went wrong during the transfer
        if (json.Status === status.RECEIPT_EMPTY
          || json.Status === status.RECEIPT_UNKOWNERROR) {
          var message = dispatch(dataActions.getTranslation(json.Message));
          dispatch(generalActions.setMessageModal(true, message));
          dispatch(generalActions.log(`Failed closeReceipt (status ${json.Status}) - ${message}: ${jsonReceipt}`));

          // Prevent logout because receipt is not saved
          dispatch(loginActions.setLogOut(false));
        } else {
          if (json.Status <= status.RECEIPT_PRINT_FAILED || json.Status === status.FISCAL_RECEIPT_PRINT_FAILED) {
            dispatch(emptyReceipt(false));
            dispatch(setPriceList(getState().generalState.defaultPricelistId));

            if (!isUserLoggingOut) {
              dispatch(openUserObject(getState().loginState.loggedin.id));
            }
          } else {
            dispatch(generalActions.setMessageModal(true, json.Message));
          }
          if (json.Status === status.FISCAL_RECEIPT_PRINT_FAILED) {
            dispatch(generalActions.setMessageModal(true, message));
          }
        }
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
      });
  };
}

function setReceiptNumber(receiptnumber, refundReceipt) {
  return {
    type: actiontypes.SET_RECEIPT_NUMBER,
    receiptnumber,
    refundReceipt
  }
}

function fetchReceiptNumber(isFetching) {
  return {
    type: actiontypes.FETCH_RECEIPT_NUMBER,
    fetchreceiptnumber: isFetching
  }
}

export function createReceipt(refundReceipt) {
  return (dispatch, getState) => {
    const posId = getState().generalState.posId;
    if (!getState().receiptState.receipt.fetchreceiptnumber) {
      dispatch(fetchReceiptNumber(true));
      const receipt = {
        PosId: posId,
        SystemUserId: getState().loginState.loggedin.id,
        Receipt: [],
        ReceiptNumber: 0,
        IsRefund: refundReceipt,
        ObjectItemId: getState().objectManagementState.selectedobjectitem.id,
        DeviceGuid: getState().generalState.uniqueid
      };

      return fetch(general.API_URL_CREATE_RECEIPT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': posId,
          'Context': 'receiptActions:createReceipt'
        },
        body: JSON.stringify(receipt)
      })
        .then(response => generalActions.checkLicense(response, dispatch))
        .then(response => response.json())
        .then(json => {
          if (json > 0) {
            return dispatch(setReceiptNumber(json, refundReceipt));
          } else {
            return dispatch(emptyReceipt());
          }
        });
    }
    else {
      return Promise.resolve();
    }
  }
}

export function createReceiptObjectManagement(refundReceipt, objectItemId,) {
  return (dispatch, getState) => {
    if (!getState().receiptState.receipt.fetchreceiptnumber) {
      const posId = getState().generalState.posId;

      dispatch(fetchReceiptNumber(true));

      const receipt = {
        PosId: posId,
        SystemUserId: getState().loginState.loggedin.id,
        Receipt: [],
        ReceiptNumber: 0,
        IsRefund: refundReceipt,
        ObjectItemId: objectItemId,
        DeviceGuid: getState().generalState.uniqueid
      };

      dispatch(generalActions.loadingStart());
      fetch(general.API_URL_CREATE_RECEIPT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': posId,
          'Context': 'receiptActions:createReceiptObjectManagement'
        },
        body: JSON.stringify(receipt)
      })
        .then(response => generalActions.checkLicense(response, dispatch))
        .then(response => response.json())
        .then(json => dispatch(setReceiptNumber(json, refundReceipt)))
        .then(() => dispatch(setObjectItem(objectItemId)))
        .then(() => dispatch(generalActions.loadingEnd()));
    }
  }
}

export function setObjectItem(objectitemid) {
  // Get the array here and update it, then pass it to unsafe
  return (dispatch, getState) => {
    let description = '';
    const objectItem = dispatch(dataActions.getObjectItem(objectitemid));
    if (objectItem !== null) {
      description = objectItem.Description;
    }
    dispatch(setReceiptObjectItemId(objectitemid, description))

    if (getState().layoutState.groups !== null && getState().layoutState.groups.items.length > 0) {
      dispatch(layoutActions.setGroup(getState().layoutState.groups.items[0].KeyLayoutGroupId))
    }

    //Production pos
    if (getState().generalState.posType === types.POSTYPE_PRODUCTIONKIOSK) {
      hashHistory.push('/production');
    }
    else {
      hashHistory.push('/overview');
    }
  }
}

function setReceiptObjectItemId(objectitemid, objectitemdescription) {
  return {
    type: actiontypes.SET_RECEIPT_OBJECT_ITEM_ID,
    objectitemid,
    objectitemdescription
  }
}

export function transferReceipt(objectitemid, openReceipt = true) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    var receipt = dispatch(receiptFunctions.saveReceipt());

    return fetch(`${general.API_URL_TRANSFER_RECEIPT}/${objectitemid}/${openReceipt}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:transferReceipt'
      },
      body: JSON.stringify(receipt)
    })
      .then(response => generalActions.checkLicense(response, dispatch))
      .then(response => response.json())
      .then(json => {
        if (json !== null) {
          if (openReceipt) {
            let lines = receiptFunctions.openReceipt(json);
            lines = dispatch(receiptFunctions.consolidateLines(lines, true));
            dispatch(receiveReceiptByObjectItem(lines, json.ReceiptNumber, json.IsRefund, json.ObjectItemId, json.ObjectItemName, json.CombinedObjectItems, json.ShouldInvoice, json.invoiceReference));
            dispatch(setObjectItem(json.ObjectItemId));
          }
        } else {
          dispatch(generalActions.setMessageModal('Fout bij het overboeken'))
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()));
  }
}

export function mergeReceipt(objectitemid) {
  return (dispatch, getState) => {
    //NOT IMPLEMENTED YET
  }
}


function updateReceipt(lines) {
  return {
    type: actiontypes.UPDATE_RECEIPTLINES,
    lines: lines
  }
}

export function updateReceiptLines(lines) {
  return (dispatch) => {
    lines.sort(function (a, b) {
      return a.id - b.id
    });
    let linesWithCustomerDiscount = dispatch(receiptFunctions.ApplyCustomerGroupDiscount(lines));
    let receiptLines = dispatch(receiptFunctions.CalculatePriceList(linesWithCustomerDiscount));
    receiptLines = receiptFunctions.CalculateDiscount(receiptLines);
    receiptLines = receiptFunctions.CalculateSubtotal(receiptLines);
    dispatch(updateReceipt(receiptLines));
  }
}

export function removeReceiptline(lineid) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.removeReceiptLine(getState, lineid)));
  }
}

export function addReceiptline(rlParam) {
  return (dispatch, getState) => {
    dispatch(addReceiptLineWithOptionalParams(rlParam, rl.GetOptional()));
  }
}

export function updateReceiptLine(receiptlines, receiptline) {
  return (dispatch, getState) => {
    receiptlines.map((line, index) => {
      if (line.id === receiptline.id) {
        receiptlines[index] = Object.assign({}, receiptline);
      }
      return '';
    })
    return receiptlines;
  }
}

export function addReceiptLineWithOptionalParams(rlParam, rlParamOptional) {
  return async (dispatch, getState) => {
    dispatch(layoutActions.setFunctionBarType(general.FUNCTIONBAR_NONE));

    let setQuantity = true;
    if (rlParam.LineType === types.ARTICLE_LINE) {
      const article = dispatch(dataActions.getArticle(rlParam.ItemId));
      if (article !== null) {
        setQuantity = !article.OpenPrice;
      }
    }

    const inputquantitynegative = getState().receiptState.input.inputquantitynegative;
    if (rlParam.Quantity === 0) {
      let quantity = parseInt(getState().receiptState.input.inputquantity, 10)
      if (quantity === 0
        || !setQuantity) {
        quantity = 1;
      } if (inputquantitynegative) {
        quantity *= -1;
      }
      rlParam.Quantity = quantity;
    } if (inputquantitynegative && rlParam.Quantity > 0) {
      rlParam.Quantity *= -1;
    }

    let isrefund = (getState().receiptState.receipt.isrefund !== null
      && getState().receiptState.receipt.isrefund);
    if (getState().receiptState.receipt.receiptnumber === null
      || getState().receiptState.receipt.receiptnumber === '') {
      dispatch(generalActions.loadingStart());
      await dispatch(createReceipt(inputquantitynegative))
      isrefund = inputquantitynegative;
      dispatch(generalActions.loadingEnd());
    }



    const license = getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox;
    //TODO: Add hasFiscalprinter to generalState
    const hasFiscalPrinter = getState().generalState.hasFiscalPrinter;
    let discountMenuArticleID = Number(getState().generalState.systemSettings[systemSetting.DISCOUNTMENU_ARTICLEID]);
    if (discountMenuArticleID === undefined) {
      discountMenuArticleID = 0;
    }
    if (hasFiscalPrinter) {
      let receiptlines = getState().receiptState.receipt.lines;
      if (receiptlines.length > 0) {
        isrefund = receiptlines.some((receiptline) => receiptline.quantity < 0);
      } else {
        isrefund = inputquantitynegative;
      }
      if (inputquantitynegative !== isrefund && rlParam.LineType === types.ARTICLE_LINE && discountMenuArticleID !== rlParam.ItemId) {
        dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ADD_NOT_POSSIBLE))));
        return;
      }
    } else if (license && !inputquantitynegative && isrefund && rlParam.LineType === types.ARTICLE_LINE && discountMenuArticleID !== rlParam.ItemId) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ADD_NOT_POSSIBLE))));
      return;
    }

    if (rlParam.LineType === types.PAYMENT_LINE) {
      rlParam.Quantity = 1;
    }

    var addLineResult = dispatch(receiptFunctions.addReceiptLine(rlParam, rlParamOptional));

    if (rlParam.LineType !== types.PAYMENT_LINE) {
      dispatch(updateReceiptLines(addLineResult.lines));
    }
    else {
      // just update the lines without recalculating price lists etc. if adding a payment line
      // because sometimes we don't want prices to get updated (e.g. when paying for a reservation)
      dispatch(updateReceipt(addLineResult.lines));
    }

    dispatch(resetInputQuantity());

    if (addLineResult.newLine) {
      const lines = $('.receipt-body');
      setTimeout(function scrollToBottom() {
        lines.scrollTop(9999);
        return this;
      }, 50);
    }

  }
}

export function startWeighArticle(article) {
  return (dispatch, getState) => {

    let device = null;
    getState().generalState.devices.map(d => {
      if (d.devicetype === 700
        && d.status <= 100) {
        device = d;
      }
      return '';
    });

    if (device === null) {
      dispatch(generalActions.setMessageModal(true, 'Geen (werkende) weegschaal aanwezig'));
      return;
    }

    const weighArticleParams = {
      SalesPrice: article.SalesPrice,
      Tarra: article.TarraWeight,
      PosDeviceGuid: getState().generalState.uniqueid,
      DeviceId: device.deviceid
    }

    fetch(general.API_URL_STARTWEIGHARTICLE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:startWeighArticle'
      },
      body: JSON.stringify(weighArticleParams)
    }).then(response => response.json())
      .then(json => {
        dispatch(modalActions.setWeightModal(true, article.ArticleId, device.deviceid));
      });
  }
}

// Fetch SalesPrice for selected PriceList
export function fetchArticleSalesPrice(article) {
  return (dispatch, getState) => {
    let salesPrice = article.SalesPrice;

    const priceListId = getState().receiptState.receipt.pricelistid;

    if (priceListId !== 0) {
      // not default pricelist, take price of selected pricelist
      for (let i = 0; i < article.PriceLists.length; i++) {
        let priceList = article.PriceLists[i];
        if (priceList.PriceListId === priceListId && !priceList.DefaultPrice) {
          salesPrice = priceList.SalesPrice;
          break;
        }
      }
    }

    return salesPrice;
  }
}

export function startCreateTicketBarcode(barcode, itemvalue, q, keyId, startDate = null, endDate = null) {
  return (dispatch, getState) => {
    fetch(general.API_URL_CHECK_TICKET_BARCODE + barcode, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:startCreateTicketBarcode'
      }
    }).then(response => response.json())
      .then(result => {
        if (result) {
          dispatch(addArticleLine(itemvalue, q, keyId, barcode, startDate, endDate));
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.BARCODE_IN_USE_MESSAGE))));
        }
      });
  }
}

export function addArticleLine(itemvalue, q = 0, keyId = 0, ticketBarcode = "", startDate = null, endDate = null, price = null, description = null, vatID = 0, enableLoading = false) {
  return async (dispatch, getState) => {
    if (enableLoading === true) {
      dispatch(generalActions.loadingStart());
    }
    if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox
      && getState().generalState.licenses.blackboxReceiptId > 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PRINT_MISSING_RECEIPT))));
      return;
    }

    // Calculate the actual quantity that will be used BEFORE checking availability
    let actualQuantity = q;
    const input = getState().receiptState.input;
    const inputquantitynegative = input.inputquantitynegative;
    
    if (actualQuantity === 0) {
      let quantity = parseFloat(input.inputquantity);
      if (quantity === 0) {
        quantity = 1;
      }
      actualQuantity = quantity;
    }
    
    // Apply negative modifier if needed
    if (inputquantitynegative && actualQuantity > 0) {
      actualQuantity *= -1;
    }

    var articleavailable = true;
    dispatch(layoutActions.getLayouts())
    
    // Only check availability if quantity is positive (not a return/refund)
    if (actualQuantity > 0 && Number.isInteger(actualQuantity)) {
      // Calculate total quantity including existing quantities on receipt
      let totalQuantityNeeded = Math.abs(actualQuantity);
      const existingLines = getState().receiptState.receipt.lines || [];
      const existingQuantity = existingLines
        .filter(line => line.linetype === types.ARTICLE_LINE && line.itemid === parseInt(itemvalue, 10))
        .reduce((sum, line) => sum + (line.quantity || 0), 0);
      
      totalQuantityNeeded += existingQuantity;

      // Pass the total quantity (existing + new) to availability check
      articleavailable = await dispatch(articleAvailable(itemvalue, totalQuantityNeeded));
    }

    if (articleavailable !== false) {
      const pos = dispatch(dataActions.getPos(getState().generalState.posId));
      if (pos !== null) {
        var rec = getState().receiptState.receipt;
        if (pos.ObjectManagementRequired
          && (!rec.objectitemdescription || rec.objectitemdescription === '' || (!rec.objectitemid || rec.objectitemid === 0))) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.OPEN_OBJECT_REQUIRED))));
          return;
        }
      }

      const article = dispatch(dataActions.getArticle(parseInt(itemvalue, 10)));

      const rlParam = rl.Get();
      if (description === null) {
        rlParam.Text = article.Description;
      } else {
        rlParam.Text = description;
      }
      rlParam.ItemId = article.ArticleId;
      rlParam.LineType = types.ARTICLE_LINE;
      rlParam.Editable = true;
      rlParam.Quantity = q;
      rlParam.KeyId = keyId;
      if (price !== null) {
        rlParam.Price = price;
      }
      rlParam.VatID = vatID;

      let amount = 0;

      let input = getState().receiptState.input;
      amount = input.inputquantity;
      var operation = amount.split("x");

      let state = getState();
      let receiptAge = state.receiptState && state.receiptState.receipt && state.receiptState.receipt.age;
      var customerAge = (receiptAge !== null && receiptAge !== undefined) ? receiptAge : state.receiptState && state.receiptState.receipt && state.receiptState.receipt.customer && state.receiptState.receipt.customer.age;
      let articleHasAgeRequirement = (article.MinimumAge && article.MinimumAge > 0) || (article.MaximumAge && article.MaximumAge > 0);
      if (articleHasAgeRequirement && (customerAge === undefined || customerAge === null || customerAge === 0)) {
        dispatch(generalActions.loadingStart());
        const posId = state.generalState.posId;

        const response = await fetch(`${general.API_URL_GET_CUSTOMER_CARD_DATA}/${posId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Context': 'CreateCustomerModal:readPassportTap'
          }
        })
        dispatch(generalActions.loadingEnd());
        var customerData = null;
        if (response.status === 200) {
          customerData = await response.json();
        }
        if (customerData === undefined || customerData === null) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ARTICLE_HAS_AGE_CONTROL))));
          return;
        }
        customerAge = customerData.Age;
        dispatch(setAge(customerAge));
      }

      if (customerAge && customerAge >= 0) {
        dispatch(setAge(customerAge));
        if (article.MinimumAge && customerAge < article.MinimumAge) {
          var minMsg = dispatch(dataActions.getTranslation(resource.ARTICLE_MINIMUM_AGE_ALERT));
          minMsg = minMsg.replace('{0}', article.MinimumAge.toString());
          minMsg = minMsg.replace('{1}', customerAge.toString());
          dispatch(generalActions.setMessageModal(true, minMsg));
          return;
        }
        if (article.MaximumAge && customerAge > article.MaximumAge) {
          var maxMsg = dispatch(dataActions.getTranslation(resource.ARTICLE_MAXIMUM_AGE_ALERT));
          maxMsg = maxMsg.replace('{0}', article.MaximumAge.toString());
          maxMsg = maxMsg.replace('{1}', customerAge.toString());
          dispatch(generalActions.setMessageModal(true, maxMsg));
          return;
        }
      }

      if (article.ManualQuantityMandatory && !article.UseScale) {
        if (amount === "0" || (article.OpenPrice && operation.length <= 1)) {
          dispatch(generalActions.setMessageModal(true, 'Handmatige invoer aantal verplicht'));
          return;
        }
      }

      if (article.OpenPrice) {
        if (amount.search("x") > -1) {
          amount = parseFloat(operation[1]);

          if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox)
            rlParam.Quantity = input.inputquantitynegative ? parseInt(operation[0], 10) * -1 : parseInt(operation[0], 10);
          else
            rlParam.Quantity = input.inputquantitynegative ? parseFloat(operation[0]) * -1 : parseFloat(operation[0]);
        }

        amount = parseFloat(amount, 10);

        if (amount === 0 || isNaN(amount)) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.MISSING_ARTICLE_PRICE))));
          return;
        }
        rlParam.Price = amount;
        // dispatch(addReceiptline(rlParam));
      }

      if (article.UseScale) {
        if (article.OpenPrice && amount) {
          article.SalesPrice = amount;
        }

        dispatch(startWeighArticle(article));
        return;
      }


      if (!article.OpenPrice) {
        let salesPrice = dispatch(fetchArticleSalesPrice(article));

        if (salesPrice === 0 && !getState().generalState.allowEmptyPrice) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.EMPTY_PRICE_NOT_ALLOWED))));
          return;
        }

        if (price === null) {
          rlParam.Price = salesPrice;
        }

        var customInput;

        if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) {
          customInput = parseInt(getState().receiptState.input.inputquantity, 10);
        }
        else {
          customInput = parseFloat(getState().receiptState.input.inputquantity);
        }

        if (customInput !== 0)
          rlParam.Quantity = customInput;
      }
      if (article.TicketTypeValidity === 300 && (startDate == null || endDate == null)) {
        dispatch(modalActions.setInputModal(true, dispatch(dataActions.getTranslation(resource.INPUT_START_DATE)), "dd/MM/yyyy", (startDateString, itemV, qua, kId) => (d, gs) => {
          if (!generalActions.isValidDate(startDateString)) {
            d(generalActions.setMessageModal(true, d(dataActions.getTranslation(resource.INPUT_INVALID_DATE))));
            return;
          }
          var sDate = generalActions.parseDate(startDateString);
          var today = new Date();
          today.setHours(0, 0, 0, 0);
          if (sDate === null || isNaN(sDate) || sDate < today) {
            d(generalActions.setMessageModal(true, d(dataActions.getTranslation(resource.INPUT_INVALID_DATE))));
            return;
          }
          d(modalActions.setInputModal(true, d(dataActions.getTranslation(resource.INPUT_END_DATE)), "dd/MM/yyyy", (endDateString, itemV2, qua2, kId2, sDate) => (d2, gs2) => {
            if (!generalActions.isValidDate(endDateString)) {
              d(generalActions.setMessageModal(true, d(dataActions.getTranslation(resource.INPUT_INVALID_DATE))));
              return;
            }
            var eDate = generalActions.parseDate(endDateString);
            if (eDate === null || isNaN(eDate) || eDate < sDate) {
              d2(generalActions.setMessageModal(true, d2(dataActions.getTranslation(resource.INPUT_INVALID_DATE))));
              return;
            }
            d2(addArticleLine(itemV2, qua2, kId2, "", sDate, eDate));
          }, [itemV, qua, kId, sDate], d));
        }, [itemvalue, q, keyId], dispatch));
        return;
      }
      if (article.TicketTypeId !== null && article.TicketTypeId > 0 && ticketBarcode === "" && article.TicketTypeProvider === "Sintrum.Pos.Providers.Ticket.Manual.ManualTicketProvider") {
        dispatch(modalActions.setInputModal(true, dispatch(dataActions.getTranslation(resource.BARCODE_INPUT_MESSAGE)), dispatch(dataActions.getTranslation(resource.BARCODE)), startCreateTicketBarcode, [itemvalue, q, keyId, startDate, endDate], dispatch));
      } else {
        if (article.TicketTypeId !== null && article.TicketTypeId > 0 && ticketBarcode !== "") {
          const rlParamOptional = rl.GetOptional();
          rlParamOptional.TicketBarcode = ticketBarcode;
          rlParamOptional.TicketStartDate = startDate;
          rlParamOptional.TicketEndDate = endDate;
          await dispatch(addReceiptLineWithOptionalParams(rlParam, rlParamOptional));
          return;
        }
        rlParam.TicketStartDate = startDate;
        rlParam.TicketEndDate = endDate;

        let actualDefaultConfigurationsLength = 0;
        if (article.Configurations.length > 0 && getState().generalState.useConfigurations) {
          const defaultConfigurations = [];
          article.Configurations.forEach(conf => {
            if (conf.DefaultValueId > 0) {
              actualDefaultConfigurationsLength++;
              defaultConfigurations.push({
                ConfigurationStepId: conf.ConfigurationStepId,
                ConfigurationStepValueId: conf.DefaultValueId,
                ConfigurationStepValueDescription: '',
                ParentConfigurationStepValueId: 0
              });
            }
            else if (article.Configurations.length === 1) {
              //If there is one configuration with one step for this article use it as default
              getState().generalState.configurationsteps.forEach(configurationStep => {
                if (configurationStep.ArticleConfigurationStepId === conf.ConfigurationStepId) {
                  configurationStep.ArticleConfigurationStepValues.forEach(val => {
                    let defaultConfiguration = {
                      ConfigurationStepId: conf.ConfigurationStepId
                    };

                    if (configurationStep.ArticleConfigurationStepValues.length === 1 && val.Type !== 300 /* Free input */) {
                      defaultConfiguration.ConfigurationStepValueId = val.ArticleConfigurationStepValueId;
                      defaultConfiguration.ConfigurationStepValueDescription = val.Description;
                      defaultConfiguration.ParentConfigurationStepValueId = 0;
                      actualDefaultConfigurationsLength++;
                    }
                    defaultConfigurations.push(defaultConfiguration);
                  });
                }
              });
            }
            else {
              defaultConfigurations.push({
                ConfigurationStepId: conf.ConfigurationStepId
              });
            }
          });

          defaultConfigurations.forEach(conf => {
            getState().generalState.configurationsteps.forEach(configurationStep => {
              if (configurationStep.ArticleConfigurationStepId === conf.ConfigurationStepId) {
                configurationStep.ArticleConfigurationStepValues.forEach(val => {
                  if (val.ArticleConfigurationStepValueId === conf.ConfigurationStepValueId) {
                    conf.ConfigurationStepValueDescription = val.Description;
                  }
                });
              }
            });
          });

          if (article.Configurations.length === actualDefaultConfigurationsLength) {
            const rlParamOptional = rl.GetOptional();
            rlParamOptional.Configuration = defaultConfigurations;
            dispatch(addReceiptLineWithOptionalParams(rlParam, rlParamOptional));
          } else {
            dispatch(generalActions.setConfigurationModal(article, defaultConfigurations, null));
          }
        } else {
          dispatch(addReceiptline(rlParam));
        }
      }
    }
    if (enableLoading === true) {
      dispatch(generalActions.loadingEnd());
    }
  }
}

const round = (value, exp) => {
  if (typeof exp === 'undefined' || +exp === 0)
    return Math.round(value);

  value = +value;
  exp = +exp;

  if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0))
    return NaN;

  // Shift
  value = value.toString().split('e');
  value = Math.round(+(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp)));

  // Shift back
  value = value.toString().split('e');
  return +(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp));
}

export function getReceiptAmount() {
  return function (dispatch, getState) {
    const state = getState();

    let receiptAmount = 0;
    state.receiptState.receipt.lines.forEach(line => {
      if (line.linetype !== types.SUBTOTAL_LINE) {
        line.discount.forEach(discount => {
          receiptAmount = round(receiptAmount + discount.Price, 2);
        })
        receiptAmount = round(receiptAmount + line.price, 2);
      }
    });

    return receiptAmount;
  }
}

export function articleAvailable(itemvalue, quantity = 1) {
  return async function (dispatch, getState) {
    var articleavailable = true;

    const url = `${general.API_URL_ARTICLE_AVAILABLE}/${itemvalue}/${getState().generalState.posId}/${quantity}`;
    await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json === false) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ARTICLE_NOT_AVAILABLE))));
          articleavailable = false;
          return;
        }
      });
    return articleavailable;
  }
}

export function hasAgeRequirement(customerAge) {
  return function (dispatch, getState) {
    const state = getState();
    var hasAgeRequirement = false;
    var minimumAgeNotReached = false;
    var maximumAgeNotReached = false;
    state.receiptState.receipt.lines.forEach(line => {
      if (line.linetype !== types.ARTICLE_LINE) { return; }
      const article = dispatch(dataActions.getArticle(line.itemid));
      let articleHasAgeRequirement = (article.MinimumAge && article.MinimumAge > 0) || (article.MaximumAge && article.MaximumAge > 0);
      if (articleHasAgeRequirement) {
        if (customerAge) {
          if (article.MinimumAge && article.MinimumAge > customerAge) {
            minimumAgeNotReached = true;
          }
          if (article.MaximumAge && article.MaximumAge < customerAge) {
            maximumAgeNotReached = true;
          }
        }
        hasAgeRequirement = articleHasAgeRequirement;
        return;
      }
    });
    return { hasAgeRequirement, minimumAgeNotReached, maximumAgeNotReached };
  }
}

export function addPaymentLineWithAmount(amount) {
  return (dispatch, getState) => {
    //Deprecated
    dispatch(generalActions.setMessageModal(true, 'Deprecated'));
  }
}

export function setPaymentDevice(paymentid, paymentAmount, receiptAmount, busy, status, oldbalance, newbalance) {
  return {
    type: actiontypes.SET_PAYMENTDEVICE,
    paymentid,
    paymentAmount,
    receiptAmount,
    busy,
    status,
    oldbalance,
    newbalance
  }
}

export function updateReceiptlineWithConfiguration(lineid, article, configuration) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.updateReceiptlineWithConfiguration(getState, lineid, article, configuration)));
  }
}

export function addQuantity(lineid) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.addQuantity(getState, lineid)));
  }
}

export function removeQuantity(lineid) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.removeQuantity(getState, lineid)));
  }
}

export function setSelectedLine(lineid) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.setSelectedLine(getState, lineid)));
  }
}

export const registerCustomerAction = () => ({
  type: actiontypes.REGISTER_CUSTOMER_ACTION
})

export function resetCustomer(checkTime) {
  return (dispatch, getState) => {
    const inPayment = getState().receiptState.receipt.paymentdevice.busy;
    const lastAction = getState().receiptState.receipt.customer.lastAction;
    const shouldInvoice = getState().receiptState.receipt.shouldinvoice;

    const resetTime = getState().generalState.resetTime > 0 ? getState().generalState.resetTime : 30000;

    const now = (new Date()).getTime();

    if (!inPayment && (!checkTime || (lastAction && lastAction.getTime() < now - resetTime))) {
      dispatch(setCustomer(-1, null, 0, false, null));
      dispatch(setPriceList(getState().generalState.defaultPricelistId));
      dispatch(updateReceiptLines(getState().receiptState.receipt.lines));

      // Reset invoice function
      if (shouldInvoice) {
        dispatch(setShouldInvoice(false));
      }
    }
  }
}

export function resetPagerNumber() {
  return (dispatch, getState) => {
    dispatch(setPagerNumber(null));
  }
}

export function overruleAge() {
  return (dispatch, getState) => {
    dispatch(setAge(-1));
  }
}

export function checkReceiptTimeout(timeout) {
  return (dispatch, getState) => {
    const paymentDevice = getState().receiptState.receipt.paymentdevice;
    const inPayment = paymentDevice.busy;
    const paymentId = paymentDevice.paymentId;
    const lastAction = timeout;
    const resetTime = getState().generalState.resetTime > 0 ? getState().generalState.resetTime : 30000;
    const now = (new Date()).getTime();

    if ((lastAction && lastAction.getTime() < now - resetTime)) {
      if (inPayment) {
        var payment = dispatch(dataActions.getPayment(paymentId));
        if (payment !== null) {
          const paymentParams = {
            PosId: getState().generalState.posId,
            DeviceId: payment.DeviceId,
            Amount: 0,
            PosDeviceGuid: getState().generalState.uniqueid
          }

          fetch(general.API_URL_ABORTPAYMENT, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(paymentParams)
          })
            .then(response => response.json())
            .then(json => {
              if (json) {
                dispatch(setPaymentDevice(0, 0, 0, false, ''));
              }
            });
        }

      }
      dispatch(emptyReceipt(true));
      dispatch(modalActions.setReservationModal(false)); // if applicable
      dispatch(modalActions.setPaymentModal(false));
      dispatch(layoutActions.clearKeyboard());
      // Return to default page
      if (getState().layoutState.defaultpage > 0) {
        dispatch(layoutActions.setGroup(getState().layoutState.defaultpage));
      }
    }
  }
}

export function checkCloseTimeout(openingTime, closingTime) {
  return (dispatch, getState) => {
    let nowDate = new Date().toISOString().split('T')[0];
    let closing = new Date(nowDate + 'T' + closingTime).getTime();
    let opening = new Date(nowDate + 'T' + openingTime).getTime();
    let now = new Date().getTime();
    if (opening < now && now < closing) {
      if (getState().layoutState.defaultpage > 0 && getState().layoutState.groupid === getState().layoutState.closepage) {
        dispatch(layoutActions.setGroup(getState().layoutState.defaultpage));
      }
    }
    else if ((opening > now || now > closing)) {
      cancelReceipt();
      if (getState().layoutState.closepage > 0 && getState().layoutState.groupid !== getState().layoutState.closepage) {
        dispatch(layoutActions.setGroup(getState().layoutState.closepage));
      }
    }
  }
}

export function startCancelReceipt() {
  return (dispatch) => {
    dispatch(generalActions.setConfirmModal(dispatch(dataActions.getTranslation(resource.MODAL_CANCEL_RECEIPT)), cancelReceipt, null));
  }
}

export function cancelReceipt() {

  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    if (getState().receiptState.receipt.lines.some(l => l.linetype === types.PAYMENT_LINE)) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.CANCEL_RECEIPT_NOT_ALLOWED))));
      dispatch(generalActions.loadingEnd());
      dispatch(generalActions.loadingEnd());
      return;
    }
    if (getState().receiptState.receipt.previousLines) {
      // if there are previousLines, this means we opened a table. In that case, we cannot cancel
      // the receipt (food has been prepared and/or served). All we can do is close the receipt without saving the new lines.
      dispatch(closeReceipt(true, true));
    }
    else {
      const receipt = dispatch(receiptFunctions.saveReceipt());
      const jsonReceipt = JSON.stringify(receipt);

      fetch(general.API_URL_CANCEL_RECEIPT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:startCancelReceipt'
        },
        body: jsonReceipt
      })
        .then(response => generalActions.checkLicense(response, dispatch))
        .then(response => response.json())
        .then(json => {
          //400 = empty receipt which means something went wrong during the transfer
          if (json.Status === status.RECEIPT_EMPTY
            || json.Status === status.RECEIPT_UNKOWNERROR) {
            var message = dispatch(dataActions.getTranslation(json.Message));
            dispatch(generalActions.setMessageModal(true, message));
            dispatch(generalActions.log(`Failed cancelReceipt (status ${json.Status}) - ${message}: ${jsonReceipt}`));
          }
          else {
            dispatch(emptyReceipt(true));
            dispatch(resetInputQuantity());

            const user = dispatch(dataActions.getSystemUser(getState().loginState.loggedin.id));
            if (user !== null
              && user.ObjectItems.length === 1) {
              const objectItem = dispatch(dataActions.getObjectItem(user.ObjectItems[0]));
              if (objectItem !== null) {
                dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
              }
            }
            else {
              const pos = dispatch(dataActions.getPos(getState().generalState.posId));
              if (pos !== null
                && pos.ObjectManagementRequired) {
                dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
                dispatch(keyFunctionActions.processObjectManagementOpen());
              }
            }
          }
          dispatch(resetCustomer());
          dispatch(resetPagerNumber());
          dispatch(generalActions.loadingEnd());
        });
    }
  }
}

export function printTest(deviceid) {
  return (dispatch, getState) => {
    var url = `${general.API_URL_PRINT_TEST}/${getState().generalState.posId}/${deviceid}`;

    dispatch(generalActions.loadingStart());
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:printTest'
      }
    })
      .then(response => response.json())
      .then(json => {
        dispatch(generalActions.updateStatus(json.DeviceId, json.Status, json.StatusMessage));
        if (json.Status === 100) {
          dispatch(
            generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PRINT_TEST)))
          );
        }
        dispatch(generalActions.loadingEnd());
      })
  }
}

export function openDrawer(noSale) {
  return (dispatch, getState) => {

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      NoSale: noSale
    }

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_OPENDRAWER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:openDrawer'
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(json => {
        let drawerStatus = status.PRINTER_OK;
        if (!json.Success) {
          drawerStatus = status.PRINTER_ERROR;
          dispatch(generalActions.setMessageModal(true, json.ErrorMessage))
        }
        if (json.DeviceId > 0) {
          dispatch(generalActions.updateStatus(json.DeviceId, drawerStatus, json.ErrorMessage));
        }
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
      });
  }
}

export function generateZReport() {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id
    }

    fetch(general.API_URL_ZREPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:generateZReport'
      },
      body: JSON.stringify(param)
    })
      .then(generalActions.checkStatus)
      .then(response => {
        dispatch(generalActions.loadingEnd());
        dispatch(layoutActions.setFunctionBarType(general.FUNCTIONBAR_NONE));

        if (response.status === 424) {
          response.json().then(deviceStatus => dispatch(generalActions.setMessageModal(true, deviceStatus.StatusMessage)));
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.Z_REPORT_GENERATED))));
        }
      });
  }
}

export function generateXReport(allPos, noBlackBox) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      AllPos: allPos,
      NoBlackBox: noBlackBox
    }

    fetch(general.API_URL_XREPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:generateXReport'
      },
      body: JSON.stringify(param)
    })
      .then(generalActions.checkStatus)
      .then(response => {
        dispatch(generalActions.loadingEnd());
        dispatch(layoutActions.setFunctionBarType(general.FUNCTIONBAR_NONE));

        if (response.status === 204) {
          dispatch(
            generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.X_REPORT_NOT_AVAILABLE)))
          );
        }
        else if (response.status === 424) {
          response.json().then(deviceStatus => dispatch(generalActions.setMessageModal(true, deviceStatus.StatusMessage)));
        }
        else {
          dispatch(
            generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.X_REPORT_GENERATED)))
          );
        }
      });
  }
}

export function printObjectReport() {
  return (dispatch, getState) => {
    var param = {
      PosId: getState().generalState.posId
    };

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_OBJECTREPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:GenerateObjectReport'
      },
      body: JSON.stringify(param)
    })
      .then(generalActions.checkStatus)
      .then(response => {
        dispatch(generalActions.loadingEnd());

        if (response.status === 424) {
          response.json().then(deviceStatus => dispatch(generalActions.setMessageModal(true, deviceStatus.StatusMessage)));
        }
      })
  }
}

export function printHistoryXZ() {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    const apiUrl = `${general.API_URL_GETHISTORYXZ}/${getState().generalState.posId}`;
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:printHistoryXZ'
      }
    })
      .then(response => response.json())
      .then(json => {
        const itemList = [];
        json.map(zreport => {
          const fromDate = formatDate(new Date(zreport.StartDate));
          const toDate = formatDate(new Date(zreport.EndDate));

          itemList.push({
            Description: `#${zreport.Number} (${fromDate} / ${toDate})`,
            ItemId: zreport.ZReportId
          })
          return '';
        })
        itemList.push({
          Description: dispatch(dataActions.getTranslation(resource.CANCEL)),
          ItemId: 0
        });
        dispatch(generalActions.setSelectModal(itemList, true, 'Selecteer rapport', continueHistoryXZ, [json]));
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
        dispatch(layoutActions.setFunctionBarType(general.FUNCTIONBAR_NONE));
      });
  }
}

//Pick two dates - api - get all between selected dates
export function printArticleReport() {
  return (dispatch, getState) => {
    const dates = new Date();
    dispatch(modalActions.setDatePickerModal(true, continuePrintArticleReport, [dates], dispatch));
  }
}

export function showCustomerBase(param) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    let setCustomer;
    try {
      setCustomer = $.parseJSON(param);
    } catch (e) {
      dispatch(generalActions.loadingEnd());
      return Promise.reject('Invalid JSON parameter');
    }

    let customerId = -1;
    if (setCustomer && setCustomer.SetCustomer) {
      customerId = parseInt(setCustomer.SetCustomer, 10);
    }

    if (customerId > -1) {
      const apiUrl = `${general.API_URL_GETCUSTOMER}${customerId}`;
      return fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:showCustomerBase'
        }
      })
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
          throw new Error('Failed to fetch customer');
        })
        .then(json => {
          dispatch(continueShowCustomerBase(json));
          dispatch(generalActions.loadingEnd());
          return json;
        })
        .catch(error => {
          dispatch(generalActions.loadingEnd());
          return Promise.reject(error);
        });
    } else {
      const customer = undefined;
      let valueList = [];
      if (setCustomer && setCustomer.SetLabel) {
        valueList = setCustomer.SetLabel
          .split(',')
          .map(s => parseInt(s, 10))
          .filter(n => !isNaN(n));
      }
      return new Promise((resolve, reject) => {
        dispatch(generalActions.loadingEnd());
        dispatch(
          modalActions.setCustomerBaseModal(
            valueList,
            true,
            c => {
              dispatch(continueShowCustomerBase(c));
              resolve(c);
            },
            [customer],
            dispatch
          )
        );
      });
    }
  };
}


export function showCustomer() {
  return (dispatch, getState) => new Promise(function (resolve, reject) {
    dispatch(generalActions.loadingStart());
    var apiUrl = ``;
    var customerId = 0;
    const param = {
      CustomerId: getState().receiptState.receipt.customer.customerid,
    }

    if (param.CustomerId > 0) {
      customerId = parseInt(param.CustomerId, 10);
      apiUrl = `${general.API_URL_GETCUSTOMER}${customerId}`;


      return fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:showCustomer'
        }
      })
        .then(response => {
          if (response.status === 200) {
            return response.json();
          }
          return null;
        })
        .then(json => {
          if (customerId > 0) {
            dispatch(modalActions.setCreateCustomerModal(true, (c) => dispatch(continueShowCustomerBase(c, resolve, reject)), null, dispatch, json.LabelIDs, json.CustomerId));
            $("#CustomerId").val(json.CustomerId);
            $('#createCustomerTitle').prop("textContent", dispatch(dataActions.getTranslation(resource.EXISTING_CUSTOMER)));
            let dateOfBirth = ((json.DateOfBirth !== null && json.DateOfBirth !== undefined) ? json.DateOfBirth : "").split("T")[0];
            let customerGroupDateTo = ((json.CustomerGroupDateTo !== null && json.CustomerGroupDateTo !== undefined) ? json.CustomerGroupDateTo : "").split("T")[0];
            $("#Name").val((json.Name !== null && json.Name !== undefined) ? json.Name : "");
            $("#Street").val((json.Street !== null && json.Street !== undefined) ? json.Street : "");
            $("#HouseNumber").val((json.HouseNumber !== null && json.HouseNumber !== undefined) ? json.HouseNumber : "");
            $("#ZipCode").val((json.ZipCode !== null && json.ZipCode !== undefined) ? json.ZipCode : "");
            $("#City").val((json.City !== null && json.City !== undefined) ? json.City : "");
            $("#DateOfBirth").val(dateOfBirth);
            $("#CustomerGroupDateTo").val(customerGroupDateTo);
            $("#TelephoneNumber1").val((json.TelephoneNumber1 !== null && json.TelephoneNumber1 !== undefined) ? json.TelephoneNumber1 : "");
            $("#Email").val((json.Email !== null && json.Email !== undefined) ? json.Email : "");
            $("#Gender").val((json.Gender !== null && json.Gender !== undefined) ? json.Gender : "");
            $("#CountryID").val((json.CountryID !== null && json.CountryID !== undefined) ? json.CountryID : "");
            $("#Badge").val((json.Badge !== null && json.Badge !== undefined) ? json.Badge : "");
            $("#CustomerGroupId").val((json.CustomerGroupId !== null && json.CustomerGroupId !== undefined) ? json.CustomerGroupId : "");
            $("#VatNumber").val((json.VatNumber !== null && json.VatNumber !== undefined) ? json.VatNumber : "");
            $("#GlnNumber").val((json.GlnNumber !== null && json.GlnNumber !== undefined) ? json.GlnNumber : "");
            if (json.AllowAfterPay === true) {
              $('#AllowAfterPay').prop("checked", true);
            }
            if (json.InvoiceOnly === true) {
              $('#InvoiceOnly').prop("checked", true);
            }
            if (json.EInvoiceActive === true) {
              $('#EInvoiceActive').prop("checked", true);
            }
            $("#IdentificationNumber").val((json.IdentificationNumber !== null && json.IdentificationNumber !== undefined) ? json.IdentificationNumber : "");
            $("#CustomerNumber").val((json.CustomerNumber !== null && json.CustomerNumber !== undefined) ? json.CustomerNumber : "");
            $("#SetLabels").val((json.LabelIDs !== null && json.LabelIDs !== undefined) ? json.LabelIDs : "");
            if (
              json.InvoiceCustomer &&
              json.InvoiceCustomer.Name &&
              json.InvoiceCustomerID
            ) {
              $("#InvoiceCustomerID").val(json.InvoiceCustomer.Name);
              // Add this block to update React state
              if (window.handleInvoiceCustomerSelect) {
                window.handleInvoiceCustomerSelect({
                  CustomerId: json.InvoiceCustomerID,
                  Name: json.InvoiceCustomer.Name
                });
              }
            } else {
              $("#InvoiceCustomerID").val("");
              // Also clear React state when no invoice customer
              if (window.handleInvoiceCustomerSelect) {
                window.handleInvoiceCustomerSelect({
                  CustomerId: '',
                  Name: ''
                });
              }
            }
          }
        }).then(() => {
          dispatch(generalActions.loadingEnd());
        });
    } else {
      dispatch(generalActions.loadingEnd());
    }
  })
}

export function showTicketBase() {
  return (dispatch, getState) => {
    dispatch(modalActions.setTicketBaseModal(true, continueShowTicketBase, null, dispatch));
  }
}

export function showArticleBase(param) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    var articleParam = $.parseJSON(param);
    var articleId = -1;
    let apiUrl = ``;

    if (articleParam && articleParam.SetArticle) {
      articleId = parseInt(articleParam.SetArticle, 10);
      dispatch(addArticleLine(articleId, 1));
      dispatch(generalActions.loadingEnd());
    }
    else {
      apiUrl = `${general.API_URL_GET_ALL_ARTICLES}${getState().generalState.posId}`;

      if (articleParam && articleParam.SetArticleGroup) {
        apiUrl = `${general.API_URL_GET_ARTICLES_BY_ARTICLEGROUP}${articleParam.SetArticleGroup}`;
      }

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:showArticleBase'
        }
      })
        .then(response => response.json())
        .then(json => {
          if (json) {
            const itemList = [];
            json.forEach(article => itemList.push(article));

            var article;
            dispatch(modalActions.setArticleBaseModal(itemList, true, continueShowArticleBase, [article], dispatch));
          }
        })
        .then(() => {
          dispatch(generalActions.loadingEnd());
        });
    }
  }
}

export function showConfigurationList(param) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    var setConfiguration = $.parseJSON(param);
    var configurationId = -1;
    var defaultConfigurationStepValueId = -1;

    if (setConfiguration && setConfiguration.SetConfiguration)
      configurationId = parseInt(setConfiguration.SetConfiguration, 10);

    if (setConfiguration && setConfiguration.SetDefaultConfiguration)
      defaultConfigurationStepValueId = parseInt(setConfiguration.SetDefaultConfiguration, 10);

    fetch(general.API_URL_LIST_CONFIGURATION, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:showConfigurationList'
      }
    })
      .then(response => response.json())
      .then(json => {
        const itemList = [];
        let setConfig = null;
        json.map(config => {

          if (config.ArticleConfigurationStepId === configurationId)
            setConfig = config;

          itemList.push({
            Config: config
          })
          return '';
        })

        if (setConfig !== null) {
          if (defaultConfigurationStepValueId > 0) {
            // Auto-select the default configuration without showing modal
            dispatch(continueConfigurationListWithDefault(setConfig, defaultConfigurationStepValueId));
          } else {
            dispatch(continueConfigurationList(setConfig));
          }
        } else {
          var configStep;
          dispatch(modalActions.setConfigurationListModal(itemList, true, continueConfigurationList, [configStep], dispatch));
        }
      }).then(() => {
        dispatch(generalActions.loadingEnd());
      });
  }
}

function continueConfigurationListWithDefault(configStep, defaultStepValueId) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    let line = receiptFunctions.getSelectedLine(getState);

    if (line === null) {
      line = receiptFunctions.getLastLine(getState);
    }

    if (line === null) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_VALID_LINES))));
      dispatch(generalActions.loadingEnd());
    }
    else {
      var originalArticle = dispatch(dataActions.getArticle(parseInt(line.itemid, 10)));
      var tempArticle = $.extend(true, {}, originalArticle);

      tempArticle.Configurations = $.extend(true, [], line.configuration);

      tempArticle.Configurations.push(
        {
          ConfigurationStepId: configStep.ArticleConfigurationStepId,
          ConfigurationStepLinkId: 0,
          DefaultValueId: defaultStepValueId,
          Order: 0
        });

      // Find the configuration step value and auto-select it
      const defaultConfigurations = [];
      getState().generalState.configurationsteps.forEach(configurationStep => {
        if (configurationStep.ArticleConfigurationStepId === configStep.ArticleConfigurationStepId) {
          configurationStep.ArticleConfigurationStepValues.forEach(val => {
            if (val.ArticleConfigurationStepValueId === defaultStepValueId) {
              defaultConfigurations.push({
                ConfigurationStepId: configStep.ArticleConfigurationStepId,
                ConfigurationStepValueId: defaultStepValueId,
                ConfigurationStepValueDescription: val.Description,
                ParentConfigurationStepValueId: 0,
                Price: val.SalesPrice
              });
            }
          });
        }
      });

      // Combine existing configurations with the new default one
      const finalConfiguration = [...line.configuration, ...defaultConfigurations];

      // Apply the configuration directly without showing modal
      dispatch(updateReceiptlineWithConfiguration(line.id, originalArticle, finalConfiguration));
      dispatch(generalActions.loadingEnd());
    }
  }
}


function continueConfigurationList(configStep) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    let line = receiptFunctions.getSelectedLine(getState);

    if (line === null) {
      line = receiptFunctions.getLastLine(getState);
    }

    if (line === null) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_VALID_LINES))));
      dispatch(generalActions.loadingEnd());
    }
    else {
      dispatch(generalActions.loadingEnd());
      var originalArticle = dispatch(dataActions.getArticle(parseInt(line.itemid, 10)));
      var tempArticle = $.extend(true, {}, originalArticle);

      tempArticle.Configurations = $.extend(true, [], line.configuration);

      tempArticle.Configurations.push(
        {
          ConfigurationStepId: configStep.ArticleConfigurationStepId,
          ConfigurationStepLinkId: 0,
          DefaultValueId: 0,
          Order: 0
        });

      dispatch(generalActions.setConfigurationModal(tempArticle, line.configuration, line.id));
      dispatch(generalActions.loadingEnd());
    }
  }
}

function continuePrintArticleReport(startDate, endDate) {
  return (dispatch, getState) => {
    var param = {
      PosId: getState().generalState.posId,
      FromDate: startDate,
      ToDate: endDate
    };

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_PRINTARTICLEREPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:continuePrintArticleReport'
      },
      body: JSON.stringify(param)
    })
      .then(generalActions.checkStatus)
      .then(response => {
        dispatch(generalActions.loadingEnd());

        if (response.status === 424) {
          response.json().then(deviceStatus => dispatch(generalActions.setMessageModal(true, deviceStatus.StatusMessage)));
        }
      })
  }
}

// function createCustomerModalCallback(customer, callback) {
//       callback
//       return;
// }    

function continueShowCustomerBase(customer, resolve, reject) {
  return (dispatch, getState) => {
    const { receiptState } = getState();

    if (customer === null || receiptState.receipt.customer.customerid === customer.CustomerId) {
      dispatch(setCustomer(null));  // TODO: investigate this. Cannot be right.
      dispatch(setPriceList(getState().generalState.defaultPricelistId));
      dispatch(updateReceiptLines(getState().receiptState.receipt.lines));
    }

    if (customer !== null && customer.CustomerGroupId > 0) {
      dispatch(generalActions.loadingStart());

      const apiUrl = `${general.API_URL_GET_CUSTOMERGROUP}${customer.CustomerGroupId}`;
      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:continueShowCustomerBase'
        }
      }).then(response => response.json())
        .then(json => {
          const item = json.PriceListId;
          const discountPercentage = json.DiscountPercentage || 0;
          dispatch(setCustomer(customer.CustomerId, customer.Name, customer.Saldo, customer.AllowAfterPay, customer.Age, customer.CustomerGroupId, json.Description, customer.InvoiceOnly, discountPercentage));
          dispatch(setPriceList(item));
          dispatch(updateReceiptLines(getState().receiptState.receipt.lines));
          if (customer.InvoiceOnly) {
            dispatch(invoiceActions.toggleInvoicingOnOff());
          }
        })
        .then(() => {
          dispatch(generalActions.loadingEnd());
          if (resolve) resolve();
        });
    }
    else if (customer !== null) {
      dispatch(setCustomer(customer.CustomerId, customer.Name, customer.Saldo, customer.AllowAfterPay, customer.Age, customer.CustomerGroupId, undefined, customer.InvoiceOnly, customer.DiscountPercentage || 0));
      dispatch(generalActions.loadingEnd());
      if (customer.InvoiceOnly) {
        dispatch(invoiceActions.toggleInvoicingOnOff());
      }
      if (resolve) resolve();
    }
    else {
      dispatch(clearCustomer());
    }
  }
}

function continueShowTicketBase(ticket) {
  return (dispatch, getState) => {

  }
}

function continueShowArticleBase(article) {
  return (dispatch, getState) => {

    if (article === null) {
      dispatch(setArticle(null));
      dispatch(updateReceiptLines(getState().receiptState.receipt.lines));
    }

    if (article !== null && article.ArticleId > 0) {
      dispatch(generalActions.loadingStart());
      dispatch(addArticleLine(article.ArticleId, 1))
      dispatch(generalActions.loadingEnd());
    }
  }
}

function formatDate(date) {
  const hour = (('0').concat(date.getHours())).slice(-2);
  const minute = (('0').concat(date.getMinutes())).slice(-2);

  const day = (('0').concat(date.getDate())).slice(-2);
  const month = (('0').concat((date.getMonth() + 1))).slice(-2);

  return `${day}-${month} ${hour}:${minute}`;
}

function continueHistoryXZ(id, description, allreports) {
  return (dispatch, getState) => {

    let report = null;
    for (let i = 0; i < allreports.length; i++) {
      if (allreports[i].ZReportId === id) {
        report = allreports[i];
        break;
      }
    }

    if (report !== null) {
      var param = {
        PosId: getState().generalState.posId,
        UserId: getState().loginState.loggedin.id,
        ZReportId: report.ZReportId,
        ZReportNumber: report.Number,
        FromDate: report.StartDate,
        ToDate: report.EndDate
      };

      dispatch(generalActions.loadingStart());
      fetch(general.API_URL_PRINTHISTORYXZ, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:continueHistoryXZ'
        },
        body: JSON.stringify(param)
      })
        .then(generalActions.checkStatus)
        .then(response => {
          dispatch(generalActions.loadingEnd());

          if (response.status === 424) {
            response.json().then(deviceStatus => dispatch(generalActions.setMessageModal(true, deviceStatus.StatusMessage)));
          }
        })
    }
  }
}

function setReceiptByObjectItem(receiptnumber, isrefund, objectitemid, objectitemname, combinedobjectitems, shouldinvoice, invoiceReference, previousLines) {
  return {
    type: actiontypes.OPEN_RECEIPT,
    receiptnumber,
    isrefund,
    objectitemid,
    objectitemname,
    combinedobjectitems,
    shouldinvoice,
    invoiceReference,
    previousLines
  }
}

function setReservationForReceipt(reservationId) {
  return {
    type: actiontypes.SET_RESERVATION_FOR_RECEIPT,
    reservationId
  }
}

function receiveReceiptByObjectItem(lines, receiptnumber, isrefund, objectitemid, objectitemname, combinedobjectitems, shouldinvoice, invoiceReference, dontRecalculate) {
  return (dispatch) => {
    dispatch(setReceiptByObjectItem(receiptnumber, isrefund, objectitemid, objectitemname, combinedobjectitems, shouldinvoice, invoiceReference, lines));
    if (dontRecalculate) {
      // this just updates the lines without recalculating the prices. This is done when we fetch a reservation. In that case we use the prices
      // at the time the reservation was made and that are stored in the previously created receipt
      dispatch(updateReceipt(lines));
    }
    else {
      // this recalculates all prices
      // so, if prices change between closing and opening a table, those prices are updated.
      dispatch(updateReceiptLines(lines));
    }
  }
}

function fetchReceiptByReceiptId(receiptId, dontRecalculatePrices) {
  return (dispatch, getState) => {
    const apiUrl = `${general.API_URL_OPEN_RECEIPT_BY_ID}${receiptId}`;
    return fetch(
      apiUrl,
      {
        headers: {
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:fetchReceiptByReceiptId'
        }
      })
      .then(response => response.json())
      .then(receipt => {
        const lines = receiptFunctions.openReceipt(receipt);

        // if we are opening a reservation, we want to keep the prices that were used at the time the reservation was made.
        // the customer might even have paid already. In that case dontRecalculatePrices is set to true
        if (!dontRecalculatePrices) {
          lines.forEach(line => {
            line.configuration.forEach(config => {
              const c = dispatch(dataActions.getArticleConfigurationStepValue(config.ConfigurationStepId, config.ConfigurationStepValueId));
              config.Price = c.SalesPrice;
            });
          });
        }

        dispatch(receiveReceiptByObjectItem(lines, receipt.ReceiptNumber, receipt.IsRefund, receipt.ObjectItemId, receipt.ObjectItemName, receipt.CombinedObjectItems, receipt.ShouldInvoice, receipt.InvoiceReference, dontRecalculatePrices));

        if (receipt.CustomerId && receipt.CustomerId > 0) {
          dispatch(showCustomerBase(`{"SetCustomer":"${receipt.CustomerId}"}`));
        }
      });
  }
}


function fetchReceiptByObjectItem(objectitemid, posid) {
  return (dispatch, getState) => {
    const apiUrl = `${general.API_URL_OPEN_RECEIPT_BY_OBJECTITEM}${objectitemid}/${posid}/${getState().loginState.loggedin.id}`;
    return fetch(
      apiUrl,
      {
        headers: {
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:fetchReceiptByObjectItem'
        }
      })
      .then(response => response.json())
      .then(receipt => {
        const lines = receiptFunctions.openReceipt(receipt);

        lines.forEach(line => {
          line.configuration.forEach(config => {
            const c = dispatch(dataActions.getArticleConfigurationStepValue(config.ConfigurationStepId, config.ConfigurationStepValueId));
            // TODO: A crash occurs here when the article configuration step value does not exist anymore
            if (c == null) { return false; }
            config.Price = c.SalesPrice;
            return true;
          });
        });

        dispatch(receiveReceiptByObjectItem(lines, receipt.ReceiptNumber, receipt.IsRefund, receipt.ObjectItemId, receipt.ObjectItemName, receipt.CombinedObjectItems, receipt.ShouldInvoice, receipt.InvoiceReference));
        dispatch(setObjectItem(receipt.ObjectItemId));

        // open (object) receipt on blackbox pos will disable receiptlines from editing
        // removing receiptlines after, ensures that these are reversed
        if (getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox) {
          dispatch(setReceiptLinesDisabledForBlackBox());
        }

        if (receipt.CustomerId && receipt.CustomerId > 0) {
          dispatch(showCustomerBase(`{"SetCustomer":"${receipt.CustomerId}"}`));
        }
      });
  }
}

export function getReceiptByReservation(reservation) {
  return dispatch =>
    dispatch(fetchReceiptByReceiptId(reservation.receiptId, true))
      .then(() => {
        dispatch(setReservationForReceipt(reservation.reservationId));
      });
}

export function getReceiptByObjectItem(objectitemid) {
  return (dispatch, getState) => dispatch(fetchReceiptByObjectItem(objectitemid, getState().generalState.posId))
}

export function getReceiptByObjectItems(objectItemId, objectItems) {
  return (dispatch, getState) => {
    const objectItemIds = [];
    for (let i = 0; i < objectItems.length; i++) {
      objectItemIds.push(objectItems[i].ObjectItemId);
    }

    const receipt = {
      PosId: getState().generalState.posId,
      SystemUserId: getState().loginState.loggedin.id,
      Receipt: [],
      ReceiptNumber: 0,
      IsRefund: false,
      ObjectItemId: objectItemId,
      CombinedObjectItems: objectItemIds,
      DeviceGuid: getState().generalState.uniqueid
    };

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_COMBINE_OBJECTS, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:getReceiptByObjectItems'
      },
      body: JSON.stringify(receipt)
    })
      .then(response => response.json())
      .then(json => {
        const lines = receiptFunctions.openReceipt(json);
        dispatch(receiveReceiptByObjectItem(lines, json.ReceiptNumber, json.IsRefund, json.ObjectItemId, json.ObjectItemName, json.CombinedObjectItems, json.ShouldInvoice, json.InvoiceReference));
        dispatch(setObjectItem(json.ObjectItemId));
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
      })
  }
}

function setReceiptObjectItemNameUnsafe(objectitemname) {
  return {
    type: actiontypes.SET_RECEIPT_OBJECT_ITEM_NAME,
    objectitemname
  }
}

export function setReceiptObjectItemName(objectitemname) {
  return (dispatch, getState) => dispatch(setReceiptObjectItemNameUnsafe(objectitemname))
}

export function workIn() {
  return (dispatch, getState) => {
    if (getState().receiptState.receipt.receiptnumber > 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
      return;
    }

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      Devices: getState().generalState.devices,
      PosDeviceGuid: getState().generalState.uniqueid
    }
    fetch(general.API_URL_WORKIN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:workIn'
      },
      body: JSON.stringify(param)
    }).then(() => {
      dispatch(generalActions.loadingEnd());
    })
  }
}

export function workOut() {
  return (dispatch, getState) => {
    if (getState().receiptState.receipt.receiptnumber > 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
      return;
    }

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      Devices: getState().generalState.devices,
      PosDeviceGuid: getState().generalState.uniqueid
    }

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_WORKOUT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:workOut'
      },
      body: JSON.stringify(param)
    }).then(() => {
      dispatch(generalActions.loadingEnd());
    })
  }
}

export function closeReceiptAndLogOut() {
  return (dispatch, getState) => {
    dispatch(closeReceipt(true, false)).then(() => {
      if (getState().loginState.logOutPossible) {
        dispatch(loginActions.logoutUser());
      }
    });
  }
}

export function setPriceList(pricelistid) {
  return {
    type: actiontypes.SET_PRICELIST,
    pricelistid
  }
}

export function setCustomer(customerId, name, saldo, allowAfterPay, age, customerGroupId, customerGroup, invoiceOnly, discountPercentage = 0) {
  return {
    type: actiontypes.SET_CUSTOMER,
    customerId,
    name,
    saldo,
    lastAction: customerId === -1 ? undefined : new Date(),
    allowAfterPay,
    age,
    customerGroupId,
    customerGroup,
    invoiceOnly,
    discountPercentage
  }
}

export function setAge(age) {
  return {
    type: actiontypes.SET_AGE,
    age
  }
}

export function setArticle(articleId, articleNumber, description) {
  return {
    type: actiontypes.SET_ARTICLE,
    articleId,
    articleNumber,
    description
  }
}

export function setOrderNumber(orderNumber) {
  return {
    type: actiontypes.SET_ORDERNUMBER,
    orderNumber,
  }
}

export function setPagerNumber(pagerNumber) {
  return {
    type: actiontypes.SET_PAGERNUMBER,
    pagerNumber,
  }
}

export function setCardName(cardname) {
  return {
    type: actiontypes.SET_CARDNAME,
    cardname
  }
}


export function clearCustomer() {
  return {
    type: actiontypes.CLEAR_CUSTOMER
  }
}


export function scaleTest(deviceId) {
  return (dispatch, getState) => {
    const url = `${general.API_URL_SCALETEST}${deviceId}`;
    dispatch(generalActions.loadingStart());
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:scaleTest'
      }
    }).then(response => response.json())
      .then(json => {
        dispatch(generalActions.updateStatus(json.DeviceId, json.ErrorCode, json.ErrorMessage));
        if (json.Status === 100) {
          dispatch(
            generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.PRINT_TEST_RECEIPT)))
          );
        }
        dispatch(generalActions.loadingEnd());
      })
  }
}

export function showManagerLogin(param) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());

    if (getState().generalState.tempRights > 0) {
      getState().generalState.tempRights = -1;
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.MANAGER_DISABLED))));
      dispatch(generalActions.loadingEnd());
    }
    else {
      fetch(general.API_URL_GET_ALL_USERS, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:showManagerLogin'
        }
      })
        .then(response => response.json())
        .then(json => {
          const userList = [];
          json.map(user => {
            userList.push({
              User: user
            })
            return '';
          })
          var manager;
          dispatch(modalActions.setManagerLoginModal(userList, true, continueManagerLogin, [manager], dispatch));

        })
        .then(() => {
          dispatch(generalActions.loadingEnd());
        });
    }
  }
}

function continueManagerLogin(manager) {
  return (dispatch, getState) => {
    //check if chosen username and password is correct and if they have the right to change receipt
    dispatch(generalActions.loadingStart());

    const managerObj = manager.User;
    managerObj.Password = manager.Password;

    fetch(general.API_URL_CHECK_USER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:continueManagerLogin'
      },
      body: JSON.stringify(managerObj)
    })
      .then(generalActions.checkStatusError)
      .then(generalActions.parseJSON)
      .then((data) => {
        switch (data.Code) {
          case 100:
            getState().generalState.tempRights = data.SystemUserId;
            dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.MANAGER_ENABLED)))); //succesfull login
            break;
          default:
            dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_INCORRECT_PASSWORD))));
            break;
        }
      })
    dispatch(generalActions.loadingEnd());
  }
}

export function saveHistoryStep(action) {
  return (dispatch, getState) => {

    const receipt = getState().receiptState.receipt.receiptnumber;
    const historyStep = {
      DateTime: new Date(),
      ManagerId: getState().generalState.tempRights,
      SystemUserId: getState().loginState.loggedin.id,
      ActionTaken: action,
      ReceiptId: receipt == null ? -1 : receipt
    }

    fetch(general.API_URL_SAVE_STEP, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:saveHistoryStep'
      },
      body: JSON.stringify(historyStep)
    })
      .then(generalActions.checkStatusError)
      .then(generalActions.parseJSON)
      .then((data) => {
        switch (data.Code) {
          case 100: //extra logging for issues
            break;
          default: //extra logging for issues
            break;
        }
      })
  }
}

export function showOrders(param) {
  return (dispatch, getState) => {
    //dispatch(generalActions.loadingStart());

    fetch(general.API_URL_GET_ORDERS, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:showOrders'
      }
    })
      .then(response => response.json())
      .then(json => {
        const orderList = [];
        json.map(order => {
          order.OrderDate = new Date(order.OrderDate);
          order.PickupDate = new Date(order.PickupDate);
          orderList.push({
            Order: order
          })
          return '';
        })
        var order;
        dispatch(modalActions.setOrderListModal(orderList, true, continueShowOrders, [order], dispatch));
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
      });
  }
}

function continueShowOrders(order) {
  return (dispatch, getState) => {
    order.OrderLines.map(line => {
      dispatch(addArticleLine(line.ArticleId, line.Quantity, line.KeyId));
      return '';
    })
    dispatch(setOrderNumber(order.OrderNumber));
    dispatch(showCustomerBase('{"SetCustomer":"' + order.CustomerId + '"}'));
  }
}

export function selectPager(param) {
  return (dispatch, getState) => {
    var pagerNumber = getState().receiptState.receipt.pagerNumber;
    dispatch(modalActions.setSelectPagerModal(true, continueSelectPager, [pagerNumber], dispatch));
  }
}

function continueSelectPager(pagerNumber) {
  return (dispatch, getState) => {
    let value = null;
    if (pagerNumber && typeof pagerNumber === 'object') {
      value = pagerNumber.PagerNumber || pagerNumber.value || null;
      if (value === '' || value === undefined) value = null;
    } else if (typeof pagerNumber === 'string' || typeof pagerNumber === 'number') {
      value = pagerNumber === '' ? null : pagerNumber;
    }
    dispatch(setPagerNumber(value));
  }
}

function payOrder(orderNumber) {
  return (dispatch, getState) => {
    fetch(general.API_URL_PAY_ORDER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:payOrder'
      },
      body: JSON.stringify(orderNumber)
    })
      .then(generalActions.checkStatusError)
      .then(generalActions.parseJSON)
      .then((data) => {
        switch (data.Code) {
          case 100: //extra logging for issues
            break;
          default: //extra logging for issues
            break;
        }
      })
  }
}

export function processObject() {
  return function (dispatch, getState) {
    const url = `${general.API_URL_SET_OBJECT_PROCESSED}${getState().receiptState.receipt.objectitemid}/${getState().generalState.posId}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:setobjectprocessed'
      }
    })
      .then(response => response.json())
      .then(result => {
        if (result) {
          dispatch(setProductionProcessed(result));
          dispatch(keyFunctionActions.processFunction(functions.ObjectManagementClose));
          dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
        }
      })
  }
}

export function getReceiptLinesToShow(lines) {
  return (dispatch, getState) => {
    let fromLine = 0;
    let toLine = 0;

    if (lines.sort((a, b) => (a.id - b.id)).filter(x => x.linetype === types.ARTICLE_LINE).length > 0) {
      let selectedLineId = (receiptFunctions.getSelectedLine(getState) !== null)
        ? receiptFunctions.getSelectedLine(getState).id
        : lines.sort((a, b) => (b.id - a.id)).filter(x => x.linetype === types.ARTICLE_LINE)[0].id;

      const subTotalLines = lines.filter(x => x.linetype === types.SUBTOTAL_LINE);

      let firstSubtotalLine = subTotalLines.sort((a, b) => (b.id - a.id)).filter(x => x.id <= selectedLineId)[0];
      fromLine = (firstSubtotalLine !== undefined) ? firstSubtotalLine.id : lines.sort((a, b) => (a.id - b.id))[0].id;

      let secondSubtotalLine = subTotalLines.sort((a, b) => (a.id - b.id)).filter(x => x.id >= selectedLineId)[0];
      toLine = (secondSubtotalLine !== undefined) ? secondSubtotalLine.id : lines.sort((a, b) => (a.id - b.id))[lines.length - 1].id;
    }

    return [fromLine, toLine];
  }
}

export function setProductionProcessed(articleIds) {
  return (dispatch, getState) => {
    dispatch(updateReceiptLines(receiptFunctions.setProductionProcessed(getState, articleIds)));
  }
}

export function setShouldInvoice(shouldInvoice) {
  return {
    type: actiontypes.SET_SHOULD_INVOICE,
    shouldInvoice
  }
}

export function setInvoiceReference(invoiceReference) {
  return {
    type: actiontypes.SET_INVOICE_REFERENCE,
    invoiceReference
  }
}

export function setTemporaryDefaultChangeId(defaultChangeId) {
  return {
    type: actiontypes.SET_TEMP_DEFAULT_CHANGE_ID,
    defaultChangeId
  }
}

export function cashIn(description, amount) {
  return (dispatch, getState) => {
    if (getState().receiptState.receipt.receiptnumber > 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
      return;
    }

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      PosDeviceGuid: getState().generalState.uniqueid,
      Description: description,
      Amount: amount
    }

    dispatch(cashRegistration(param));
  }
}

export function cashOut(description, amount) {
  return (dispatch, getState) => {
    if (getState().receiptState.receipt.receiptnumber > 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.RECEIPT_IS_OPEN))));
      return;
    }

    const param = {
      PosId: getState().generalState.posId,
      UserId: getState().loginState.loggedin.id,
      PosDeviceGuid: getState().generalState.uniqueid,
      Description: description,
      Amount: amount * -1
    }

    dispatch(cashRegistration(param));
  }
}

export function cashRegistration(param) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_CASH_REGISTRATION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:cashRegistration'
      },
      body: JSON.stringify(param)
    }).then(response => response.json())
      .then(json => {
        if (json && json.DeviceStates) {
          json.DeviceStates.map((state) => {
            if (state.Status >= status.RECEIPT_PRINT_FAILED) {
              dispatch(generalActions.setMessageModal(true, state.StatusMessage));
            }
            return true;
          })
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()));
  }
}

export function setReceiptLinesDisabledForBlackBox() {
  return (dispatch) => {
    dispatch({
      type: actiontypes.DISABLE_EDIT_BLACK_BOX_LINES
    })
  }
}

export function parkOrder(param) {
  return (dispatch, getState) => {
    // Do not park empty receipts
    if (getState().receiptState.receipt && getState().receiptState.receipt.lines.length === 0) {
      return;
    }

    var setObjectGroup = $.parseJSON(param);
    var objectGroupId = -1;

    if (setObjectGroup && setObjectGroup.SetObjectGroup) {
      objectGroupId = parseInt(setObjectGroup.SetObjectGroup, 10);
    }

    // Get objectitems that have no link to servants or receipts
    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_GET_FREE_OBJECTITEM + objectGroupId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:parkOrder'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json && json.ObjectItemId > 0) {
          dispatch(continueParkOrder(json.ObjectItemId));
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_FREE_OBJECT))));
        }
      })
      .then(() => {
        dispatch(generalActions.loadingEnd());
      })
  }
}

function continueParkOrder(objectItemId) {
  return (dispatch, getState) => {
    fetch(`${general.API_URL_GET_ALL_ARTICLES}${getState().generalState.posId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:continueParkOrder'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json) {
          // Select article from list that are linked to the default ticket provider
          var articles = json.filter(a => a.TicketTypeProvider === types.DEFAULT_TICKETTYPE_PROVIDER);

          if (articles.length === 1) {
            dispatch(createDefaultTicket(articles[0], objectItemId));
          }
          else {
            var article;
            dispatch(modalActions.setArticleBaseModal(articles, true, createDefaultTicket, [objectItemId, article], dispatch));
          }
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ARTICLES_NOT_FOUND))));
        }
      })
  }
}

function createDefaultTicket(article, objectItemId) {
  return (dispatch, getState) => {
    // Article must be available to create ticket
    if (!article || article.ArticleId <= 0 || article.TicketTypeProvider !== types.DEFAULT_TICKETTYPE_PROVIDER) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ARTICLE_INFO_NOT_FOUND))));
      return;
    }

    fetch(`${general.API_URL_CREATE_DEFAULT_TICKET}${article.ArticleId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:createDefaultTicket'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json && json.TicketId) {
          // Link ticket and transfer to object
          dispatch(transferReceiptAndLinkTicketToObject(json.TicketId, objectItemId));
        }
        else {
          dispatch(modalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_MESSAGE_CREATING_DEFAULT_TICKET))));
        }
      })
  }
}

function transferReceiptAndLinkTicketToObject(ticketId, objectItemId) {
  return (dispatch, getState) => {
    // Ticket and object must be available for link
    if (!ticketId || ticketId <= 0 || !objectItemId || objectItemId <= 0) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.TICKET_OBJECT_UNKNOWN))));
      return;
    }

    // Continue if receiptprinter is available
    const receiptPrinter = getState().generalState.devices.find(device => device.printertype === 100);
    if (!receiptPrinter || receiptPrinter.Status > status.PRINTER_OK) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_WORKING_PRINTER))));
      return;
    }

    let receiptAmount = dispatch(getReceiptAmount());

    dispatch(openUserObject(getState().loginState.loggedin.id));
    if (getState().layoutState.defaultpage > 0) {
      dispatch(layoutActions.setGroup(getState().layoutState.defaultpage));
    }

    dispatch(transferReceipt(objectItemId, false))
      .then(() => {
        dispatch(emptyReceipt(true));

        return fetch(`${general.API_URL_LINK_TICKET_TO_OBJECT}${ticketId}/${objectItemId}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'PosId': getState().generalState.posId,
            'Context': 'receiptActions:linkTicketToObjectAndTransferReceipt'
          }
        })
          .then(response => response.json())
          .then(json => {
            if (!json || json.TicketId < 0) {
              dispatch(modalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_MESSAGE_LINK_TICKET_TO_OBJECT))));
            }
            else {
              // Print ticket
              dispatch(printTicketWithAmount(json.TicketId, receiptAmount, receiptPrinter.deviceid, receiptPrinter.posdevicelinkid));
            }
          });
      })
      .catch(() => {
        dispatch(modalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_MESSAGE_LINK_TICKET_TO_OBJECT))));
      });
  }
}

export function printTicketWithAmount(ticketId, receiptAmount, deviceId, posDeviceLinkId) {
  return (dispatch, getState) => {
    const param = {
      TicketId: ticketId,
      Amount: receiptAmount,
      DeviceId: deviceId,
      PosDeviceLinkId: posDeviceLinkId
    }

    dispatch(generalActions.loadingStart());
    fetch(general.API_URL_PRINT_TICKET_WITH_AMOUNT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:printTicketWithAmount'
      },
      body: JSON.stringify(param)
    })
      .then(response => response.json())
      .then(json => {
        if (json && json.Status >= status.RECEIPT_PRINT_FAILED) {
          dispatch(generalActions.setMessageModal(true, json.StatusMessage));
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()));
  }
}

function openUserObject(userId) {
  return dispatch => {
    const user = dispatch(dataActions.getSystemUser(userId));
    if (user !== null && user.ObjectItems.length === 1) {
      const objectItem = dispatch(dataActions.getObjectItem(user.ObjectItems[0]));
      if (objectItem !== null) {
        // Set object if user is linked to object
        dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
      }
      else {
        dispatch(setObjectManagementPage());
      }
    }
    else {
      dispatch(setObjectManagementPage());
    }
  }
}

export function clearObjectItem(objectItemId) {
  return (dispatch, getState) => {

    dispatch(generalActions.loadingStart());
    const posid = getState().generalState.posId;
    const apiUrl = `${general.API_URL_CLEAR_OBJECTITEM}?objectItemId=${objectItemId}&&posID=${posid}`;
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:clearObjectItem'
      }
    })
      .then(() => {
        dispatch(emptyReceipt(true));
        dispatch(resetInputQuantity());

        const user = dispatch(dataActions.getSystemUser(getState().loginState.loggedin.id));
        if (user !== null
          && user.ObjectItems.length === 1) {
          const objectItem = dispatch(dataActions.getObjectItem(user.ObjectItems[0]));
          if (objectItem !== null) {
            dispatch(keyFunctionActions.continueObjectManagementOpen(objectItem));
          }
        }
        else {
          const pos = dispatch(dataActions.getPos(getState().generalState.posId));
          if (pos !== null
            && pos.ObjectManagementRequired) {
            dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
            dispatch(keyFunctionActions.processObjectManagementOpen());
          }
        }
      })
      .then(() => dispatch(generalActions.loadingEnd()));
  }
}

function setObjectManagementPage() {
  return (dispatch, getState) => {
    // Set objectmanagement page if objectmanagement is required for pos
    const pos = dispatch(dataActions.getPos(getState().generalState.posId));
    if (pos !== null
      && pos.ObjectManagementRequired
      && pos.PosType === types.POSTYPE_NORMAL) {
      dispatch(generalActions.setKeyFunctionExecuted(functions.ObjectManagementOpen));
      dispatch(keyFunctionActions.processObjectManagementOpen());
    }
  }
}

export function handleDiscountMenu() {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    const discountMenuArticleID = getState().generalState.systemSettings[systemSetting.DISCOUNTMENU_ARTICLEID];
    if (discountMenuArticleID !== null && discountMenuArticleID !== undefined && discountMenuArticleID !== 0) {
      const isBlackbox = getState().generalState.licenses.blackbox && getState().generalState.hasBlackbox;
      const discountMenuId = Number(discountMenuArticleID);
      const currentLines = getState().receiptState.receipt.lines;

      if (isBlackbox) {
        const processedLines = [];
        currentLines.forEach(line => {
          if (line.itemid === discountMenuId) {
            if (line.blackBox_disable_edit) {
              processedLines.push(line);
              processedLines.push({
                ...line,
                quantity: line.quantity * -1,
                price: line.price * -1,
                discount: [],
                editable: false,
                selected: false,
                blackBox_disable_edit: false
              });
            }
          } else {
            processedLines.push(line);
          }
        });
        dispatch(updateReceiptLines(processedLines));
      } else {
        dispatch(updateReceiptLines(currentLines.filter(line => line.itemid !== discountMenuId)));
      }

      const linesForApi = getState().receiptState.receipt.lines.filter(
        line => line.itemid !== discountMenuId
      );
      fetch(general.API_URL_FETCH_DISCOUNT_MENU, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:FetchDiscountMenu'
        },
        body: JSON.stringify(linesForApi)
      })
        .then(response => response.json())
        .then(async json => {
          json.sort((a, b) => a.Description.localeCompare(b.Description));
          await Promise.all(json.map(discountmenu =>
            dispatch(addArticleLine(discountmenu.ArticleId,
              discountmenu.Quantity, 0, "", null, null,
              discountmenu.Discount, discountmenu.Description, discountmenu.VatID, true))
          ));
        })
        .then(() => dispatch(generalActions.loadingEnd()));
    } else {
      dispatch(generalActions.loadingEnd());
    }
  }
}





// WEBPACK FOOTER //
// src/actions/receiptActions.js